import React                   from 'react';
import DialogContent           from '@mui/material/DialogContent';
import DialogActions           from '@mui/material/DialogActions';
import Button                  from '../inputs/Button';
import Dialog                  from '@mui/material/Dialog';
import {Trans, useTranslation} from 'react-i18next';
import RichAlert               from '../feeback/RichAlert';
import DialogTitle             from '@mui/material/DialogTitle';
import {massMailCancel}        from '../../../store/actions/MassMailAction';
import {connect}               from 'react-redux';

const MassMailCancelDialog = ({massMailId, open, setOpen, cancelling, cancel}) => {
	const {t} = useTranslation();

	const handleClose = () => {
		setOpen(false);
	};

	const handleReady = () => {
		cancel(massMailId).then(handleClose);
	};

	return (
		<Dialog
			open={open}
			fullWidth
		>
			<DialogTitle>{t('massmail_cancel_title')}</DialogTitle>

			<DialogContent>
				<RichAlert severity="warning">
					<Trans i18nKey={'massmail_cancel_warn'}>
						sample<br/>
						<strong>sample</strong>
					</Trans>
				</RichAlert>
			</DialogContent>

			<DialogActions>
				<Button color="secondary" autoFocus onClick={handleClose} disabled={cancelling}>
					{t('close_btn')}
				</Button>
				<Button loading={cancelling} color="primary" variant="contained" onClick={handleReady}
				        disabled={cancelling}
				>
					{t('cancel_btn')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};


const mapStateToProps = (state) => {
	return {
		cancelling: state.massMail.cancelling,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		cancel: (massMailId) => dispatch(massMailCancel(massMailId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MassMailCancelDialog);

